import useEvent from './useEvent';

export default useEvent;
